import React, { useEffect, useState } from "react";
import moment from 'moment';
import './style.scss';

const formats = ['mm:ss', 'HH:mm:ss'];

const ProgressBar = ({ r, xy, width, height, countDown, timeout }) => {

    const strokeDasharray = 2 * Math.PI * r;
    const strokeDashoffset = strokeDasharray * (1 - countDown / timeout);

    return <svg width={width} height={height} viewBox={`0 0 ${width} ${width}`} className="c-countdown-progress-bar">
        <circle
            r={r} cx={xy} cy={xy}
            fill="transparent"
            strokeWidth={r / 10}
            className="c-countdown-progress-bar-track"
        />
        <circle
            r={r} cx={xy} cy={xy}
            fill="transparent"
            strokeWidth={r / 10}
            className="c-countdown-progress-bar-progress"
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
        />
    </svg>
}

const CCountDown = ({ start = moment().unix(), timeout = 0, format = formats[0], onTimeOut = () => {}, radius }) => {

    const r = radius || 30;
    const xy = r + r / 15;
    const width = xy * 2;
    const height = width;

    const [countDown, setCountDown] = useState(start + timeout - moment().unix());

    useEffect(() => {
        let interval;
        if (start + timeout - moment().unix() > 0) {
            interval = setInterval(() => {
                const _countDown = start + timeout - moment().unix();
                setCountDown(_countDown);
                if (_countDown < 1) {
                    onTimeOut();
                    clearInterval(interval);
                }
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [start, timeout])

    return (
        <div className="c-countdown" style={{ width, height }}>
            <ProgressBar r={r} xy={xy} width={width} height={height} countDown={countDown} timeout={timeout || 1} />
            <span className="c-countdown-timeout">{moment.utc(countDown * 1000).format(format)}</span>
        </div>
    )
}

export default CCountDown;